import { render } from "./OrderFilters.vue?vue&type=template&id=1da2cb78&scoped=true&ts=true"
import script from "./OrderFilters.ts?vue&type=script&lang=ts"
export * from "./OrderFilters.ts?vue&type=script&lang=ts"

import "./OrderFilters.vue?vue&type=style&index=0&id=1da2cb78&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da2cb78"]])

export default __exports__